import React from "react";

const SummaryCard = ({ title, value, loading = false }) => (
  <div className="min-w-[170px] w-full h-[90px] rounded-[10px] bg-[#5BAFD710] border border-[#5BAFD720] flex flex-col justify-center items-center relative overflow-hidden">
    {loading && (
      <div className="absolute inset-0 bg-[#1a1a1a80] flex items-center justify-center">
        <div className="w-5 h-5 border-2 border-[#5BAFD7] border-t-transparent rounded-full animate-spin"></div>
      </div>
    )}
    
    <span className="text-[#5BAFD7] font-['Public Sans'] font-bold text-[14px] leading-[22px] text-center mb-1">
      {title}
    </span>
    
    <span className="text-[#E3E3E3] font-['Public Sans'] font-bold text-[20px] leading-[22px] text-center">
      {loading ? "..." : formatValue(title, value)}
    </span>
  </div>
);

const formatValue = (title, value) => {
  if (typeof value !== "number") return value || "0";
  
  switch (title) {
    case "Active Subscriptions":
    case "Coupons Applied":
      return value.toLocaleString();
    
    case "Total Revenue":
      return `$${value.toLocaleString('en-US', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      })}`;
    
    case "Avg. Subscription Value":
      return `$${value.toLocaleString('en-US', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      })}`;
    
    default:
      return value.toString();
  }
};

const SubscriptionSummary = ({ data, loading = false }) => {
  const {
    activeSubscriptions = 0,
    totalRevenue = 0,
    avgValue = 0,
    couponsApplied = 0,
  } = data || {};

  return (
    <div className="w-full bg-[#111111d6] border border-[#505050] rounded-lg p-5 mb-6">
      <h2 className="text-[#E3E3E3] font-['Public Sans'] font-bold text-[20px] leading-[22px] mb-5">
        Summary
      </h2>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <SummaryCard 
          title="Active Subscriptions" 
          value={activeSubscriptions} 
          loading={loading}
        />
        <SummaryCard 
          title="Total Revenue" 
          value={totalRevenue} 
          loading={loading}
        />
        <SummaryCard 
          title="Avg. Subscription Value" 
          value={avgValue} 
          loading={loading}
        />
        <SummaryCard 
          title="Coupons Applied" 
          value={couponsApplied} 
          loading={loading}
        />
      </div>
    </div>
  );
};

export default SubscriptionSummary;